import React from "react";
import { CheckOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { InputHook } from "components/hook-forms";
import { ClearAllIcon } from "components/svgs";
import { useForm } from "react-hook-form";

const LocationsFilter = ({ defaultValues = {}, setShowFilter, submitFilter }) => {
  const {
    reset,
    getValues,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: "onSubmit",
    defaultValues: defaultValues
  });

  const submitForm = async (values) => {
    submitFilter(values);
  };

  return (
    <div className="filter-order-component">
      <form onSubmit={handleSubmit(submitForm)}>
        <div className="wrap-form-filter">
          <InputHook
            control={control}
            placeholder="Location Name"
            label="Location Name"
            name="locationName"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Address"
            label="Address"
            name="address"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Contact Phone"
            label="Contact Phone"
            name="contactPhone"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Contact Email"
            label="Contact Email"
            name="contactEmail"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
          <InputHook
            control={control}
            placeholder="Salesperson"
            label="Salesperson"
            name="salesperson"
            showOptionsName={false}
            errors={errors}
            suffix={<SearchOutlined />}
          />
        </div>
        <div className="wrap-button">
          <Button
            type="link"
            className="collapse"
            onClick={() => setShowFilter && setShowFilter(false)}
          >
            Collapse <UpOutlined />
          </Button>
          <Button
            type="link"
            className="svg-icon clear"
            onClick={() => {
              reset();
            }}
          >
            Clear <ClearAllIcon />
          </Button>
          <Button type="primary" htmlType="submit">
            Apply <CheckOutlined />
          </Button>
        </div>
      </form>
    </div>
  );
};

export default LocationsFilter;
